// src/components/ui/PageError.jsx

import React from 'react';
import { getCardStyle } from './pageTheme';
import { COLORS } from '../../constants';

export default function PageError({ message }) {
  return (
    <div style={{ ...getCardStyle(), padding: 24, color: COLORS.danger, fontWeight: 700 }}>
      {message}
    </div>
  );
}
